<template>
  <div class="loader">
    <div class="background">
      <div class="progress">
        <div class="icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "ImageLoader"
}
</script>

<style lang="scss" scoped>
.background {
  height: 75px;
  width: 79px;
  background-image: url(../../assets/images/Background.svg);
}
.progress {
  -webkit-animation: attachmentLoading 2s linear infinite alternate;
  animation: attachmentLoading 2s linear infinite alternate;
  height: 75px;
  width: 79px;
  display: flex;
  justify-content: center; align-items: center;
  background-position: 0 -450%;
  background-repeat: repeat-x;
  background-image: url(../../assets/images/Fill.svg);
  -webkit-mask-image: url(../../assets/images/Mask.svg);
  -webkit-mask-size: 80px 75px;
  mask-image: url(../../assets/images/Mask.svg);
  mask-size: 80px 75px;
}
.icon {
  height: 35px;
  width: 43px;
  background-image: url(/wp-content/themes/cg-ideaboard/images/Loader/Image.svg);
}

@keyframes attachmentLoading {
  0% {
    background-position: 0 -450%;
  }
  100% {
    background-position: 0 100%;
  }
}

@-webkit-keyframes attachmentLoading {
  0% {
    background-position: 0 -450%;
  }
  100% {
    background-position: 0 100%;
  }
}


</style>
